module.exports = __webpack_public_path__ + "img/36.c8e0fd7e.png";